var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ny-main',{attrs:{"title":"Infinities 广告主平台","platform":"ad-user","route-data":_vm.routeData}})}
var staticRenderFns = []

export { render, staticRenderFns }